module.exports = __webpack_public_path__ + "img/cp4.e29dac99.jpg";